import '../scss/main.scss';

import ESData from './helpers/Data';
import { initObserver } from "./helpers/IntersectionObserver";
import { setScroll } from "./helpers/Scroll";
import { setViewport, getBreakpoint } from "./helpers/Viewport";
import Header from './helpers/Header';
import { isPdfExportMode } from './helpers/PdfExportMode';
import 'focus-visible/dist/focus-visible.min.js';

const Turbolinks = isPdfExportMode() ? require('turbolinks') : null;

class Entry {
  
  init = () => {
    const _is_pdf = isPdfExportMode();
    if (_is_pdf){
      const _usa_temp = document.querySelector('.pdf-usa-template');
      const _states_temp = document.querySelector('.pdf-states-template');
      var fragment = window.location.hash;
      console.log("091924 fragment", fragment);
      if (fragment) {
        _usa_temp.remove();
      }else{
        _states_temp.remove();
      }
    }
    if (_is_pdf) Turbolinks.start();

    this.currentView = null;

    initObserver({
      threshold: .5
    });

    this.bindEvents();

    document.addEventListener("turbolinks:before-visit", e => {
      if (getBreakpoint() === 'mobile') {
        this.header.toggleMobileMenu(false)
      }
    });

    document.addEventListener("turbolinks:visit", e => {
      if (this.currentView) this.currentView.hide();
    });

    document.addEventListener("turbolinks:load", e => {
      this.currentSlug =  e.data.url;
      // this.header.update(this.currentSlug);
      this.pageLoaded();
     });

     document.addEventListener('turbolinks:before-cache', e => {
       console.log('before:cache')
       if (this.currentView) {
         this.currentView.destroy()
         this.currentView = null
       }
     })/**/

    this.pageLoaded();

    console.log('090924 turbolinks:load');
    // STEPS TO POPULATE PDF TEMPLATE
    if (_is_pdf){
      setTimeout(() => {
          //SOURCES
          const sourceOverview1 = window.refURL !== "" ? document.querySelector('.es-landing-heatmap-legend-stateperyear') : document.querySelector('.es-landing-heatmap-legend-totaldeaths');
          const sourceOverviewUSA2 = document.querySelector('.es-landing-blurb-deaths-usa');
          const sourceTime1a = document.querySelector('.source-time-1a');
          const sourceTime1 = document.querySelector('.es-landing-linechart-legend-stateIncrease');
          const sourceCost1 = document.querySelector('.es-landing-margin-top');
          const sourceIntent1 = document.querySelector('.es-suicide-state-perc');
          const sourceIntent2 = document.querySelector('.es-homicide-state-perc');
          const sourceIntent2Nat = document.querySelector('.es-homicide-national-perc');
          const sourceSuicideUSAWhite = document.querySelector('.es-race-ethnicity-national-suicide-comparison');
          const sourceHomicideUSABlack = document.querySelector('.es-race-ethnicity-national-homicide-comparison');
          const sourceHomicideChildrenTeen = document.querySelector('.-black-child-teen');
          const sourceChildTeenHomicide = document.querySelector('.es-children-teen-state-perc-homicide');
          const sourceChildTeenSuicide = document.querySelector('.es-children-teen-state-perc-suicide');
          const sourceTimeUS1 = document.querySelector('.es-landing-linechart-legend-nationalIncrease');
          const sourceChildTeenUSASuicide = document.querySelector('.es-children-teen-national-perc-suicide');
          const sourceChildTeenUSAHomicide = document.querySelector('.es-children-teen-national-perc-homicide');
          const sourceIPHUS = document.querySelector('.es-iph-national-perc');
          // -----> PAGE 2

          //TARGETS
          const _overview1 = document.querySelector('.-overview--1');
          const _dcThe = document.querySelector('.-dc-the');
          const _dcNoThe = document.querySelector('.-dc-no-the');
          if (_dcNoThe && _dcNoThe.innerHTML === "the District of Columbia"){
            _dcNoThe.innerHTML = "District of Columbia"
            _dcThe ? _dcThe.innerHTML = "the " : null;
          }else{
            _dcThe ? _dcThe.innerHTML = "" : null;
          }
          // provisional 
          let provisional_toggle = true; //false; // set to true to display " (provisional)" note in all applicable citations.
          const provisionals = document.querySelectorAll('.-provisional');
          let pStat = ESData.provisionalStatus();
          console.log("030626 pStat", pStat);
          console.log("030626 provisional_toggle", provisional_toggle);
          provisionals.forEach(el => {
            console.log("030626 el", el);
            console.log("030626 el.classlist", el.classList);
            console.log("030626 el.classlist[1]", el.classList[1]);
            console.log("030626 pStat.__classes[el", pStat.__classes);
            console.log("030626 pStat.__classes[el.classList[1]]", pStat.__classes[el.classList[1]]);
            //el.innerHTML = provisional_toggle ? ' (provisional)' : '';
            el.innerHTML = pStat.__classes[el.classList[1]].status ? '' : ' (provisional)';
          });

          const _overviewUSA2 = document.querySelector('.-overview--usa-2');
          const _overview2 = document.querySelector('.-overview--2');
          const _overview3 = document.querySelector('.-overview--3');
          const _lastYearA = document.querySelector('.-last-year-a');
          //const _iphYear = document.querySelector('.-iph--year'); //IPH year no longer used 
          const _firstYearA = document.querySelector('.-first-year-a');
          const _time1a = document.querySelector('.-time--1a');
          const _time1 = document.querySelector('.-time--1');
          const _time2a = document.querySelector('.-time--2a');
          const _time2 = document.querySelector('.-time--2');
          const _time2Cond = document.querySelector('.-time--2-cond');
          const _time2CondNat = document.querySelector('.-time--2-cond-nat');
          const _time3a = document.querySelector('.-time--3a');
          const _time3 = document.querySelector('.-time--3');
          const _time3Cond = document.querySelector('.-time--3-cond');
          const _time3CondNat = document.querySelector('.-time--3-cond-nat');
          const _time23And = document.querySelector('.-time--2-3-and');
          const _time23AndNat = document.querySelector('.-time--2-3-and-nat');
          const _time23RespectivelyNat = document.querySelector('.-time--2-3-respectively-nat');
          const _time23NationwideNat = document.querySelector('.-time--2-3-nationwide-nat');
          const _time23NationwideInnerNat = document.querySelector('.-time--2-3-nationwide-inner-nat');
          const _timeHomicideMissing = document.querySelector('.-time--homicide-missing');
          const _timeMissingFirstYears = document.querySelectorAll('.-time-missing-first-year');
          const _timeMissingLastYears = document.querySelectorAll('.-time-missing-last-year');
          const _marginTopFirstPage = document.querySelector('.--margin-top-first-page');
          const _timeSuicideMissing = document.querySelector('.-time--suicide-missing');
          const _timeUS1 = document.querySelector('.-us-time-1');
          const _timeUS1Direction = document.querySelector('.-us-time-1-direction');
          const _timeUS2 = document.querySelector('.-us-time-2');
          const _timeUS3 = document.querySelector('.-us-time-3');
          const _timeUS2DirectionNoun = document.querySelector('.-us-time-2-direction-noun');
          const _timeUS3DirectionNoun = document.querySelector('.-us-time-3-direction-noun');
          const _timeUS2DirectionVerb = document.querySelector('.-us-time-2-direction-verb');
          const _timeUS3DirectionVerb = document.querySelector('.-us-time-3-direction-verb');
          const _cost1 = document.querySelector('.-cost--1');
          const _cost2 = document.querySelector('.-cost--2');
          const _cost2USA = document.querySelector('.-cost--2-usa');
          const _cost3 = document.querySelector('.-cost--3');
          const _intent1 = document.querySelector('.-intent--1');
          const _intentStateHighDeaths = document.querySelector('.-intent--state-high-deaths');
          const _intentStateHighSuicide = document.querySelector('.-intent--state-high-suicide');
          const _intentStateHighHomicide = document.querySelector('.-intent--state-high-homicide');
          const _intent2 = document.querySelector('.-intent--2');
          const _intentUS1 = document.querySelector('.-intent-us-1');
          const _intentUS2 = document.querySelector('.-intent-us-2');
          const _updated1 = document.querySelector('.-updated--1');
          const _updated2 = document.querySelector('.-updated--2');
          const _iphUS1 = document.querySelector('.-iph-us-1');
          const _iphUS1a = document.querySelector('.-iph-us-1a');
          // -----> PAGE 2
          const _suicide1 = document.querySelector('.-suicide--1');
          const _suicide2 = document.querySelector('.-suicide--2');
          const _suicide2Cond = document.querySelector('.-suicide--2-cond');
          const _suicide3 = document.querySelector('.-suicide--3');
          const _suicide3Cond = document.querySelector('.-suicide--3-cond');
          const _suicide23Disclaimer = document.querySelector('.-suicide--2-3-disclaimer');
          const _suicide4 = document.querySelector('.-suicide--4');
          const _suicide5 = document.querySelector('.-suicide--5');
          const _suicideUSAWhite = document.querySelector('.-suicide--usa-white');
          const _homicideUSAWhite = document.querySelector('.-homicide--usa-white');
          const _homicide1 = document.querySelector('.-homicide--1');
          const _homicide1Cond = document.querySelector('.-homicide--1-cond');
          const _homicide1Cond2 = document.querySelector('.-homicide--1-cond2');
          const _homicide2 = document.querySelector('.-homicide--2');
          const _homicide3 = document.querySelector('.-homicide--3');
          const _homicide3Cond = document.querySelector('.-homicide--3-cond');
          const _homicide13Disclaimer = document.querySelector('.-homicide--1-3-disclaimer');
          const _homicideHomicideAssaultsSuppress = document.querySelector('.-homicide--homicide-assaults-suppress');
          const _homicide4 = document.querySelector('.-homicide--4');
          const _homicide5 = document.querySelector('.-homicide--5');
          const _homicide6 = document.querySelector('.-homicide--6');
          const _homicideUS1 = document.querySelector('.-homicide-us-1');
          const _child1 = document.querySelector('.-child--1');
          const _child1Tie = document.querySelector('.-child--1-tie');
          const _child1NA = document.querySelector('.-child--1-na');
          const _child2 = document.querySelector('.-child--2');
          const _child2Disclaimer = document.querySelector('.-child--2-disclaimer');
          const _child2Cond = document.querySelector('.-child--2-cond');
          const _child4 = document.querySelector('.-child--3');
          const _childBlack = document.querySelector('.-child--black');
          const _child3 = document.querySelector('.-child--4');
          const _childUS1 = document.querySelector('.-child-us-1');
          const _childUS2 = document.querySelector('.-child-us-2');
          const _iph1 = document.querySelector('.-iph--1');
          const _iph2 = document.querySelector('.-iph--2');
          const _iphAllNA = document.querySelector('.-iph-all-na');
          const _iph1Disclaimer = document.querySelector('.-iph--1-disclaimer');
          const _iph1Cond = document.querySelector('.-iph--1-cond');
          // ----> CITATIONS
          const _citationP11 = document.querySelector('.-citation--P11');
          const _citationP12 = document.querySelector('.-citation--P12');
          const _citationP21 = document.querySelector('.-citation--P21');
          const _citationP22 = document.querySelector('.-citation--P22');
          const _citationP13 = document.querySelector('.-citation--P13');
          const _citationP14 = document.querySelector('.-citation--P14');
          const _citationP15 = document.querySelector('.-citation--P15');
          const _citationP23 = document.querySelector('.-citation--P23');
          const _citationP24 = document.querySelector('.-citation--P24');
          const _citationP25 = document.querySelector('.-citation--P25');
          const _citationP26 = document.querySelector('.-citation--P26');
          //const _citationP27 = document.querySelector('.-citation--P27');
          const _citationP28 = document.querySelector('.-citation--P28');
          const _citationP28Year = document.querySelector('.-citation--P28-year');
          const _citationP29 = document.querySelector('.-citation--P29');
          const _capitalizeDC = document.querySelector('.-capitalize-dc');
          const _capitalizeDC2 = document.querySelector('.-capitalize-dc2');
          const _capitalizeDC3 = document.querySelector('.-capitalize-dc3');
          const _capitalizeDC4 = document.querySelector('.-capitalize-dc4');

          //POPULATE PDF TEMPLATE
          if (_capitalizeDC){
            _capitalizeDC.innerHTML = _capitalizeDC.innerHTML.replace("the District", "The District");
            _capitalizeDC2.innerHTML = _capitalizeDC2.innerHTML.replace("the District", "The District");
            _capitalizeDC3.innerHTML = _capitalizeDC3.innerHTML.replace("the District", "The District");
            _capitalizeDC4.innerHTML = _capitalizeDC4.innerHTML.replace("the District", "The District");
          }
          _overview1.innerHTML = sourceOverview1?.innerHTML;
          _overviewUSA2 ? _overviewUSA2.innerHTML = sourceOverviewUSA2?.innerHTML : null;
          _overview2.innerHTML = window.sourceOverview2;
          _overview3 ? _overview3.innerHTML = window.source_allgvrank : null;
          _firstYearA ? _firstYearA.innerHTML = window.firstYear : null;
          _lastYearA ? _lastYearA.innerHTML = window.lastYear : null;
          _timeMissingFirstYears.forEach(element => element.innerHTML = window.firstYear);
          _timeMissingLastYears.forEach(element => element.innerHTML = window.lastYear);
          //_iphYear ? _iphYear.innerHTML = window.iphYear : null;
          //console.log("122325 sourceTime1a",sourceTime1a);
          //console.log("122325 sourceTime1a.innerHTML",sourceTime1a.innerHTML);
          _time1a.innerHTML = sourceTime1a 
            ? sourceTime1a.innerHTML === " stayed the same" // 
              ? "<span class='-es-number'>stayed the same</span>"
              : sourceTime1a.innerHTML // Note that the inner HTML is being assigned to the element here.
            : window.nationalIncrease > 0 
              ? "increased" 
              :  window.nationalIncrease == 0 
                ? "stayed the same" 
                : "decreased";
          _time1.innerHTML = sourceTime1?.innerHTML;
          _time2a ? _time2a.innerHTML = window.sourceTime2a : null;
          if (window.sourceTime2a !== "n/a"){
            if (window.sourceTime2a !== "stayed the same"){
              _time2 ? _time2.innerHTML = window.sourceTime2 : null;
            }else{
              _time2 ? _time2.innerHTML = "" : null;
              _time2a.innerHTML = `<span class="-es-number">${window.sourceTime2a}</span>`;
            }
            if(window.sourceTime3a === "n/a"){
              _time23And.innerHTML = "";
              _time23AndNat.innerHTML = "";
            }
          }else{
            _time2Cond.innerHTML = "";
            _time2CondNat.innerHTML = "";
          }
          if (window.sourceTime3a !== "n/a"){
            _time3a ? _time3a.innerHTML = window.sourceTime3a : null;
            _time3 ? _time3.innerHTML = window.sourceTime3 : null;
          }else{
            _time3Cond.innerHTML = "";
            _time3CondNat.innerHTML = "";
          }
          if (window.sourceTime2a === "n/a" || window.sourceTime3a === "n/a"){
            _time23RespectivelyNat ? _time23RespectivelyNat.innerHTML = "" : null;
          }
          console.log("101524",window.sourceTime2a, window.sourceTime3a);
          let marginTop = "50px";
          if (window.sourceTime2a === "n/a"){
            _time23NationwideNat.innerHTML = "";
            //_marginTopFirstPage ? _marginTopFirstPage.style.marginTop = "30px" : null;
            marginTop = "30px";
          }else{
            _timeSuicideMissing ? _timeSuicideMissing.innerHTML = "" : null;
            marginTop = "50px";
          }
          if (window.sourceTime3a !== "n/a"){
            _time23NationwideInnerNat ? _time23NationwideInnerNat.innerHTML = "" : null;
            _timeHomicideMissing ? _timeHomicideMissing.innerHTML = "" : null;
            //_marginTopFirstPage ? _marginTopFirstPage.style.marginTop = "50px" : null;
            if (marginTop === "50px"){
              marginTop = "50px";
            }
          }else{
            //_marginTopFirstPage ? _marginTopFirstPage.style.marginTop = "30px" : null;
            if (marginTop === "50px"){
              marginTop = "30px";
            }
          }
          _marginTopFirstPage ? _marginTopFirstPage.style.marginTop = marginTop : null;
          _timeUS1 ? _timeUS1.innerHTML = sourceTimeUS1?.innerHTML : null;
          _timeUS1Direction ? _timeUS1Direction.innerText = window.nationalIncrease < 0 ? "decrease" : "increase" : null;
          const nationalSuicideChange = Number.parseFloat(window._nationalSuicidePctDifference);
          const nationalHomicideChange = Number.parseFloat(window._nationalHomicidePctDifference);
          _timeUS2 ? _timeUS2.innerHTML = Number.isNaN(nationalSuicideChange) ? window._nationalSuicidePctDifference : `${Math.abs(nationalSuicideChange)}%` : null;
          _timeUS3 ? _timeUS3.innerHTML = Number.isNaN(nationalHomicideChange) ? window._nationalHomicidePctDifference : `${Math.abs(nationalHomicideChange)}%` : null;
          _timeUS2DirectionNoun ? _timeUS2DirectionNoun.innerText = nationalSuicideChange < 0 ? "decrease" : "increase" : null;
          _timeUS3DirectionNoun ? _timeUS3DirectionNoun.innerText = nationalHomicideChange < 0 ? "decrease" : "increase" : null;
          _timeUS2DirectionVerb ? _timeUS2DirectionVerb.innerText = nationalSuicideChange < 0 ? "decreased" : "increased" : null;
          _timeUS3DirectionVerb ? _timeUS3DirectionVerb.innerText = nationalHomicideChange < 0 ? "decreased" : "increased" : null;
          _cost1 ? _cost1.innerHTML = window.sourceCost1 : null;
          _cost2 ? _cost2.innerHTML = window.sourceCost2 : null;
          _cost2USA ? _cost2USA.innerHTML = window.sourceCost2USA : null;
          _cost3.innerHTML = sourceCost1?.innerHTML;
          _intent1 ? _intent1.innerHTML = sourceIntent1?.innerHTML : null;
          if (fragment) {
            _intent2.innerHTML = sourceIntent2?.innerHTML;
          }else{
            _intent2 ? intent2.innerHTML = sourceIntent2Nat?.innerHTML : null;
            _intentStateHighDeaths.innerHTML = window.age_adj_rate_sorted_state_deaths[0].state;
            _intentStateHighSuicide.innerHTML = window.age_adj_rate_sorted_state_suicide[0].state;
            _intentStateHighHomicide.innerHTML = window.age_adj_rate_sorted_state_homicide[0].state === 'District of Columbia' 
              ? `the ${window.age_adj_rate_sorted_state_homicide[0].state}`
              : window.age_adj_rate_sorted_state_homicide[0].state;
          }
          _intentUS1 ? _intentUS1.innerHTML = window.usSuicideTotalPct.toString() + "%" : null;
          _intentUS2 ? _intentUS2.innerHTML = window.usHomicideTotalPct.toString() + "%" : null;
          _iphUS1 ? _iphUS1.innerHTML = sourceIPHUS.innerHTML : null;
          _iphUS1a ? _iphUS1a.innerHTML = sourceIPHUS.innerHTML : null;
          // -----> PAGE 2
          _suicide1.innerHTML = Math.round(window.sourceSuicide1).toLocaleString();
          _suicide2.innerHTML = Math.round(window.sourceSuicide2).toLocaleString();
          if (window.sourceSuicide2 < 10){
            _suicide2Cond.innerHTML = "";
          }
          _suicide3.innerHTML = window.sourceSuicide3 ? window.sourceSuicide3.toFixed(1).toLocaleString() : "";
          if (window.sourceSuicide2 < 10){
            _suicide3Cond.innerHTML = "";
          }else{
            _suicide23Disclaimer ? _suicide23Disclaimer.innerHTML = "" : null;
          }
          _suicide4 ? _suicide4.innerHTML = window.sourceSuicide4 ? window.sourceSuicide4.toLocaleString() : "" : null;
          _suicide5 ? _suicide5.innerHTML = window.sourceSuicide5 ? window.sourceSuicide5.toLocaleString() : "" : null;
          _suicideUSAWhite ? _suicideUSAWhite.innerHTML = sourceSuicideUSAWhite.innerHTML.replace("x","") + " times" : null;
          _homicide1.innerHTML = Math.round(window.sourceHomicide1).toLocaleString();
          console.log("D092724 window.sourceHomicide1", window.sourceHomicide1);
          console.log("D092724 window.sourceHomicide2", window.sourceHomicide2);
          console.log("D092724 window.sourceHomicide3", window.sourceHomicide3);
          if ((window.sourceHomicide1 < 10)&&(window.sourceHomicide2 >= 11)){
            _homicide1Cond.innerHTML = "";
            _homicide3Cond.innerHTML = "";
            _homicideHomicideAssaultsSuppress ? _homicideHomicideAssaultsSuppress.innerHTML = "" : null;
          }else{
            _homicide1Cond2.innerHTML = "";
            _homicide13Disclaimer ? _homicide13Disclaimer.innerHTML = "" : null;
          }
          _homicide2.innerHTML = window.sourceHomicide2;
          _homicide3.innerHTML = window.sourceHomicide3 ? window.sourceHomicide3.toFixed(1).toLocaleString() : "";
          _homicide4.innerHTML = window.source_homicide_assaults;
          _homicide5 ? _homicide5.innerHTML = window.source_homiciderank : null;
          _homicideUSAWhite ? _homicideUSAWhite.innerHTML = sourceHomicideUSABlack.innerHTML.replace("x","") + " times" : null;
          _homicide6 ? _homicide6.innerHTML = window.sourceHomicide6 : null;
          _homicideUS1 ? _homicideUS1.innerHTML = window._nationalPercHomicideGun : null;
          _child1.innerHTML = window.sourceChild1;
          if (window.sourceChild1Tied){
            _child1Tie.innerHTML = "tied for ";
          }else{
            _child1Tie.innerHTML = "";
          }
          if (window.sourceChild1 === "n/a"){
            _child1NA.innerHTML = "";
          }
          _child2.innerHTML = Math.round(window.sourceChild2).toLocaleString();       
          if (window.sourceChild2 < 10){
            _child2.innerHTML = "fewer than 10";
          }
          if (window.sourceChild2 < 10 && window.sourceChild3 === 0 && window.sourceChild4 === 0){
            _child2Cond.innerHTML = "";
          }else{
            _child2Disclaimer ? _child2Disclaimer.innerHTML = "" : null;
          }
          console.log("A060325 _childBlack", _childBlack);
          console.log("A060325 _childBlack.innerHTML", _childBlack?.innerHTML);
          console.log("A060325 sourceHomicideChildrenTeen", sourceHomicideChildrenTeen);
          console.log("A060325 sourceHomicideChildrenTeen.innerHTML", sourceHomicideChildrenTeen?.innerHTML);
          _childBlack ? _childBlack.innerHTML = sourceHomicideChildrenTeen?.innerHTML : null;
          console.log("C092124 sourceChildTeenHomicide", sourceChildTeenHomicide);
          console.log("C092124 sourceChildTeenSuicide", sourceChildTeenSuicide);
          _child4.innerHTML = sourceChildTeenSuicide.innerHTML.replace("&lt;", "fewer than "); //`${Math.round(window.sourceChild3 * 100).toLocaleString()}%`;
          _child3.innerHTML = sourceChildTeenHomicide.innerHTML.replace("&lt;", "fewer than "); ; //`${Math.round(window.sourceChild4 * 100).toLocaleString()}%`;
          _childUS2 ? _childUS2.innerHTML = sourceChildTeenUSAHomicide.innerHTML : null;
          _childUS1 ? _childUS1.innerHTML = sourceChildTeenUSASuicide.innerHTML : null;
          if (window.sourceIph1 < 10){
            _iph1.innerHTML = "fewer than 10";
            if (window.sourceIph1 === 0 || !window.sourceIph1){
              //e.g., 2024 Hawaii and Kentucky
              _iph1Cond.innerHTML = "";
            }else{
              _iph1Disclaimer.innerHTML = "";
            }
          }else{
            _iph1.innerHTML = Math.round(window.sourceIph1);  //(iphData.stateFemDeathsPerYear < 10) ? "<10" : ESData.numberWithCommas( Math.round(iphData.stateFemDeathsPerYear) )
            _iph1Disclaimer.innerHTML = "";
          }
          _iph2.innerHTML = `${Math.round(window.sourceIph2 * 100)}%`;//(iphData.stateFemDeathsPerYear < 10) ? "<10" : ESData.numberWithCommas( Math.round(iphData.stateFemDeathsPerYear) )
          if (window.iphAllNA){
            _iphAllNA.style.opacity = 0;
            _iphAllNA.style.position = 'absolute';
            _iphAllNA.style.top = '-100px';
          }else{
            _iph1Disclaimer.innerHTML = "";
          }
          //if (window.sourceIph1 < 10 || window.iphAllNA){
          //  _iphAllNA.style.opacity = 0;
          //}
          const currentDate = new Date();
          const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
          ];
          const currentMonth = monthNames[currentDate.getMonth()]; // getMonth() returns a zero-based month index
          const currentYear = currentDate.getFullYear();
          const formattedDate = `${currentMonth} ${currentYear}`;
          _updated1.innerHTML = formattedDate;
          _updated2.innerHTML = formattedDate;
          _citationP11.innerHTML = window.first_year_es_all_demographics;
          _citationP12.innerHTML = window.last_year_es_all_demographics;
          _citationP21.innerHTML = window.first_year_es_all_demographics;
          _citationP22.innerHTML = window.last_year_es_all_demographics;
          _citationP13.innerHTML = window.first_year_es_trends_by_intent_and_year;
          _citationP14.innerHTML = window.last_year_es_trends_by_intent_and_year;
          _citationP15.innerHTML = window.last_year_es_gun_injuries_landscape;
          _citationP23.innerHTML = window.last_year_es_gun_injuries_landscape;
          _citationP24.innerHTML = window.first_year_es_gun_deaths_children_teens;
          _citationP25.innerHTML = window.last_year_es_gun_deaths_children_teens;
          _citationP26.innerHTML = window.year_es_leading_cause_of_death;
          //_citationP27.innerHTML = window.year_es_intimate_partner_homicide;
          _citationP28Year.innerHTML = window.first_year_es_firearm_intimate_partner_homicide_year;
          _citationP28.innerHTML = window.first_year_es_firearm_intimate_partner_homicide;
          _citationP29.innerHTML = window.last_year_es_firearm_intimate_partner_homicide;

          if (fragment === "#DistrictofColumbia" || fragment === "#District of Columbia" || fragment === "#District%20of%20Columbia" || fragment === ""){
            const pdfSpecialCase = document.querySelector('.pdf-special-case');
            pdfSpecialCase.style.paddingBottom = "25px";
            const pdfSpecialCase2 = document.querySelector('.pdf-special-case-2');
            pdfSpecialCase2.style.marginTop = "40px";
          }
          

      }, 5000); // Delay in milliseconds (5000 ms = 5 seconds)
    }
    this.$elt = document.body;
    this.$html = document.documentElement;

    this.mobileBp = 768

    this.layout = 'desktop'

    this.header = new Header(this.$elt.querySelector('.es-headerwrapper'))

  };

  bindEvents() {
    window.addEventListener(
      "scroll",
      () => {
        this.scrollTicket = true;
      },
      false
    );
    window.requestAnimationFrame(this.onUpdate);
    window.addEventListener("orientationchange", () => this.onResize(), false);
    window.addEventListener("resize", () => this.onResize(), false);
  }

  onHeaderResize = (iscondensed) => {
    if(this.currentView && this.currentView.onHeaderResize) {
      this.currentView.onHeaderResize(iscondensed);
    }
  }

  onUpdate = () => {
    if (typeof window === "undefined") return;
    if (this.scrollTicket) {
      this.scrollTicket = false;

      const scrollObj = {
        y: window.scrollY || window.pageYOffset
      };

      setScroll(scrollObj);
    }

    window.requestAnimationFrame(this.onUpdate);
  };

  onResize = () => {
    const viewportObj = {
      width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
      height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
      pageHeight: Math.max(this.$elt.scrollHeight, this.$elt.offsetHeight, this.$html.clientHeight, this.$html.scrollHeight, this.$html.offsetHeight)
    };
    setViewport(viewportObj);
  }

  pageLoaded = () => {
    // Routing
    const currentPage = document.querySelector("#everystat-content").firstElementChild;
    // console.log("pageLoaded -- " + currentPage.id);

    switch (currentPage.id) {
      case "everystat-landing-page":
        import(/* webpackChunkName: "homepage" */ "./classes/Landing")
          .then(this.currentViewImported)
          .catch(error =>
            console.log(
              "An error occurred while loading the Homepage component",
              error
            )
          );
        break;
      case "everystat-faqs-page":
        import(/* webpackChunkName: "homepage" */ "./classes/FAQs")
          .then(this.currentViewImported)
          .catch(error =>
            console.log(
              "An error occurred while loading the Homepage component",
              error
            )
          );
        break;
      case "everystat-database-page":
        import(/* webpackChunkName: "homepage" */ "./classes/DB")
          .then(this.currentViewImported)
          .catch(error =>
            console.log(
              "An error occurred while loading the Homepage component",
              error
            )
          );
        break;
      default:
        // this.currentViewImported({ default: PageView }, currentPage);
        break;
    }
  };

  currentViewImported = async (
    { default: CurrentModule },
    el = null,
    options = {}
  ) => {
    if (this.currentView) {
      this.currentView.dispose();
    }
    this.currentView = new CurrentModule(el, options);

    this.currentView.init();
    this.currentView.show();
  };

}
const entry = new Entry();

document.addEventListener("DOMContentLoaded", () => {
  entry.init();
  console.log("080723 entry", entry);
  //console.log("080723 stateList", stateList);
}, false);
